<form [formGroup]="form">
  <div class="form-row">
    <label>{{ "USERS.CENTERS" | translate }}</label>
    <app-center-select formControlName="centers"></app-center-select>
  </div>
  <div class="form-row">
    <label for="arztNr">{{ "USERS.ARTZNR" | translate }}</label>
    <input type="text" id="arztNr" pInputText formControlName="arztNr" maxlength="16" />
  </div>
</form>
